import { Injectable } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class SystemModule{
  SysModID:number;
  SysModName:string;
  ModuleRouteName:string;
  ModuleImageClass:string;
  SysSubModList:SystemSubModule[];
 
}


export class SystemSubModule
{
    SysModID :number;
    SysSubModID:number; 
    SequenceNo:number;
    SysSubModName:string;
    SubModuleImageClass:string;
    SysSubModShrtName:string;
    SysProgList:SystemProgram[];
    
}



export class SystemProgram
{
  SysProgID:number;
  GridFormToOpen:string;
  SysProgName :string;
  Path :string;
  PrgImgClass:string;
    isaddable :string;
    isupdatable :string;
    isdeletable:string;
    isprintable:string;
    isReadOnly :string;
    Instruction:string;
    InStructionInDevnagri:string;
}
export class ContactSuport {
  TeacherName: string;
  SubjectName: string;
  Designation: string;
  MobileNo: string;
};

let ContactSuportlist: ContactSuport[] = [
  {
    TeacherName: "Shri. Gurav Dilip Pandurang",
    SubjectName: "Arts Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9822199864"
  },
  {
    TeacherName: "Shri. Jadhav Dasharath Naryan",
    SubjectName: "Arts Branch",
    Designation: "Asistant Teacher",
    MobileNo: "7875252140"
  },
  {
    TeacherName: "Shri. Aarde Dhanaji Jotram",
    SubjectName: "Arts Branch",
    Designation: "Asistant Teacher",
    MobileNo: "8378937575"
  },
    {
    TeacherName: "Shri. Kene Sattappa Baburao",
    SubjectName: "Arts Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9503120404"
  },
   {
    TeacherName: "Shri. Patil Sangarm Sjan",
    SubjectName: "Arts Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9822522832"
  },
   {
    TeacherName: "Shri. Patil Shantaram Baburao",
    SubjectName: "Arts Branch",
    Designation: "Asistant Teacher",
    MobileNo: "7020937121"
  },
   {
    TeacherName: "Sou. Ingavlae Shital Chandrakant",
    SubjectName: "Commernce Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9765158026"
  },
   {
    TeacherName: "Shri. Kamble Dhanaji Antu",
    SubjectName: "Commernce Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9421110245"
  },
   {
    TeacherName: "Sou. Varne Savitha Sudhir",
    SubjectName: "Commernce Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9623534423"
  },
   {
    TeacherName: "Shri. Patil Ashutosh Bhaskar",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9404409296"
  },
  {
    TeacherName: "Shri. Jitkar Sunil Jayvant",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9421288234"
  },
   {
    TeacherName: "Sou. Shivsharan Vishkha Sukhdev",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9834180372"
  },
   {
    TeacherName: "Sou. Chavan Sushila Ganpathrao",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9284235119"
  },
   {
    TeacherName: "Shri. Desai Sagar Namdev",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "8855044416"
  },
   {
    TeacherName: "Shri. Farakate Arvind Dattatrya",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9623438741"
  },
    {
    TeacherName: "Shri. Mhske Kishor Machindra",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9890111387"
  },
    {
    TeacherName: "Sou. Patil Nilima Vijay",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "9175059066"
  },
   {
    TeacherName: "Sou. Mandhare Anuradha Rahul",
    SubjectName: "Science Branch",
    Designation: "Asistant Teacher",
    MobileNo: "7588112303"
  },
  {
    TeacherName: "Shri. Abiitkar R.S.",
    SubjectName: "Office",
    Designation: "Clerk",
    MobileNo: "9421204660"
  },
  {
    TeacherName: "Shri. Chorge S.S",
    SubjectName: "Office",
    Designation: "Clerk",
    MobileNo: "9607329808"
  },
   {
    TeacherName: "Shri. Davang B.B",
    SubjectName: "",
    Designation: "Vice Principal",
    MobileNo: "9421206381"
  },
];
@Injectable({
  providedIn: 'root'
})
export class SystemmenuService {

  constructor(private dataService: DataAccessService) { }

  public getAllMenuByGroupId(systemGroupId:string,SelectedLanguage:string) {debugger
    this.dataService.setControllerName = '/SystemUser/';
    this.dataService.setMethodName = 'GetSystemModuleList?SysUserGrpID=' + systemGroupId + '&SelectedLanguage='+ SelectedLanguage + ''; // setting method name from API controller.
    return this.dataService.getAll<SystemModule[]>()
  }
  public getAllParentMenuByGroupId(systemGroupId:string,SelectedLanguage:string) {debugger
    this.dataService.setControllerName = '/SystemUser/';
    this.dataService.setMethodName = 'GetParentSystemModuleList?SysUserGrpID=' + systemGroupId + '&SelectedLanguage='+ SelectedLanguage + ''; // setting method name from API controller.
    return this.dataService.getAll<SystemModule[]>()
  }
  public GetUserGroupIDforPortal() {debugger
    this.dataService.setControllerName = '/SystemUser/';
    this.dataService.setMethodName = 'GetUserGroupIDforPortal?SequenceNo=1'; // setting method name from API controller.
    return this.dataService.getAll<SystemModule[]>()
  }
  public GetContactList() {debugger
    /* this.dataService.setControllerName = '/SystemUser/';
    this.dataService.setMethodName = 'GetContactList'; // setting method name from API controller.
    return this.dataService.getAll<ContactSuport[]>() */
    return ContactSuportlist;
  }
  public GetUserGroupIDforParentPortal() {debugger
    this.dataService.setControllerName = '/SystemUser/';
    this.dataService.setMethodName = 'GetUserGroupIDforPortal?SequenceNo=17'; // setting method name from API controller.
    return this.dataService.getAll<SystemModule[]>()
  }
}
